import React from 'react';
import Modal from 'react-native-modal';
import { Flex, PrimaryButton, Typography } from '@banhala/ui-kit';
import { getScreenWidth } from 'shared/src/utils/getScreenWidth/getScreenWidth';
import { DownloadQR } from './DownloadQR';

export const AppDownloadModal: React.FC<{
  visible: boolean;
  onRequestClose: () => void;
}> = props => {
  return (
    <Modal
      isVisible={props.visible}
      animationIn={'fadeIn'}
      animationOut={'fadeOut'}
      style={{
        margin: 0,
        padding: 0,
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onBackdropPress={props.onRequestClose}
      onBackButtonPress={props.onRequestClose}
    >
      <Flex
        backgroundColor={'white'}
        width={getScreenWidth() - 64}
        borderRadius={12}
        padding={{ top: 24, bottom: 16, horizontal: 16 }}
      >
        <Flex alignItems={'center'} margin={{ bottom: 16 }}>
          <Typography type="h4" color={'content_primary'}>
            해당 기능은 앱에서 사용 가능해요!
          </Typography>
          <Typography type="body1" color={'content_secondary'}>
            앱 설치하고 더 편하게 쇼핑해보세요
          </Typography>
          <Flex
            margin={{ top: 20, bottom: 16 }}
            width={100}
            height={100}
            borderColor={'border_secondary'}
            borderWidth={1}
            borderRadius={12}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <DownloadQR></DownloadQR>
          </Flex>
          <Typography type="body2" color={'content_secondary'}>
            휴대폰으로 QR 코드를 스캔해서 설치해보세요
          </Typography>
        </Flex>

        <PrimaryButton
          variant={'fill'}
          size={'medium'}
          onPress={props.onRequestClose}
        >
          확인
        </PrimaryButton>
      </Flex>
    </Modal>
  );
};
